module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Analogico-HF-4.196c2ff2.png";